import React, { useState } from 'react';
import './Team.css';

function TeamMembers({ name, role, image, details }) {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <div className="team-card">
                <img src={image} alt={name} />
                <h3>{name}</h3>
                <p className="role">{role}</p>
                <button onClick={() => setShowModal(true)} className="read-more-btn">
                    Read More
                </button>
            </div>

            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-btn" onClick={() => setShowModal(false)}>✖</button>
                        <h3>{name}</h3>
                        <p className="role">{role}</p>
                        {details.map((line, i) => (
                            <p key={i}>{line}</p>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
}

export default TeamMembers;
